import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Divider,
} from "@mui/material";

import configServ from "../../services/config";
import toast from "react-hot-toast";

const JudgeCardDialog = ({
  isEdit,
  editData,
  handlePopup,
  refreshData,
  company_id,
  setIsEdit,
  setEditData
}) => {
  const [judgeName, setJudgeName] = useState("");
  const [status, setStatus] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEdit && editData) {
      setJudgeName(editData.judge_name || "");
      setStatus(editData.status);
    } else {
      setJudgeName("");
      setStatus(true);
    }
  }, [isEdit, editData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!judgeName.trim()) {
      toast.error("Judge Name is required");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        company_id: company_id,
        judge_name: judgeName,
        status: status,
        id: isEdit && editData ? editData.id : undefined,
      };

      if (isEdit) {
        // console.log("Edit Data:", editData);

        const response = await configServ.updateJudgeName(
          payload
        );

        if (response.status) {
          toast.success("Judge Updated Successfully");
          refreshData();
          handlePopup();
          setIsEdit(false);
          setEditData(null);
        }
      } else {
        const response = await configServ.createJudgeName(payload);
        if (response.status) {
          toast.success("Judge Created Successfully");
          refreshData();
          handlePopup();
          setIsEdit(false);
          setEditData(null);
        }
      }
    } catch (err) {
      console.error(err);

      if (err.response) {
        console.log(err.response.data);
        alert(err.response.data.message || "Something went wrong");
      } else {
        alert(err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={true}
      onClose={handlePopup}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <Typography variant="h6" fontWeight="bold">
          {isEdit ? "Update Judge Name" : "Create Judge Name"}
        </Typography>
      </DialogTitle>

      <Divider />

      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                label="Judge Name"
                value={judgeName}
                onChange={(e) => setJudgeName(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>

                <Select
                  value={status}
                  label="Status"
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <MenuItem value={true}>Active</MenuItem>
                  <MenuItem value={false}>Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>

        <Divider />

        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="outlined"
            color="error"
            onClick={handlePopup}
          >
            Cancel
          </Button>

          <Button
            type="submit"
            variant="contained"
            disabled={loading}
          >
            {loading
              ? "Please Wait..."
              : isEdit
                ? "Update"
                : "Save"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default JudgeCardDialog;